export default __webpack_public_path__ + "static/media/profile.a4ed3e15.jpg";